export * from './SystemSettingTypesPageLazy';
export * from './SystemSettingTypeUpdatePageLazy';
